var Realtimeboard = {};

function Common() {
	this.config = {
		publicApi: undefined,
		locale: 'en',
		clickEvent: 'click',
		user: {}
	}
}

Common.prototype.redirect = function (inUrl, inAbsolute) {
	var url = inUrl || undefined;
	if (!url) {
		return;
	}
	var absolute = inAbsolute || false;

	if (!absolute && this.config.locale != 'en') {
		url = '/' + this.config.locale + url;
	}

	window.top.location = url;
};

Common.prototype.cookie = {
	set: function (name, value, expires, path, domain, secure) {
		var str = '';

		secure = (!!secure || true) && location.protocol.indexOf('https') > -1;

		str += name + "=" + escape(value) + "; ";
		str += 'expires=' + (expires != undefined ? this.setExpiration(expires) : this.setExpiration(expires ? expires : 30)) + '; ';
		str += 'path=' + (path ? path : '/') + '; ';

		if (domain) {
			str += "domain=" + domain + "; ";
		}

		if (secure) {
			str += "secure; ";
		}

		document.cookie = str;
	},

	setExpiration: function (cookieLife) {
		var today = new Date();
		var expr = new Date(cookieLife ? (today.getTime() + cookieLife * 24 * 60 * 60 * 1000) : 0);
		return expr.toGMTString();
	},

	get: function (name) {
		var matches = document.cookie.match(new RegExp(
			"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		));

		return matches ? decodeURIComponent(matches[1]) : undefined
	},

	remove: function (name) {
		this.set(name, '', 0);
	}
};

Common.prototype.Date = function (inMs, inSettings) {
	var ms = parseInt(inMs) || undefined;
	if (!ms) {
		throw new TypeError;
	}

	var settings = inSettings || {};
	settings.locale = settings.locale || this.config.locale;

	var months = {
		ru: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
		en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};

	var days = {
		ru: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
		en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};

	var date = new Date(ms), minutes = date.getMinutes();

	if (minutes < 10) {
		minutes = '0' + minutes;
	}

	return {
		month: months[settings.locale][date.getMonth()],
		monthNumber: date.getMonth() + 1,
		day: date.getDate(),
		dayOfWeek: {
			number: date.getDay(),
			name: days[settings.locale][date.getDay()]
		},
		year: date.getFullYear(),
		hours: date.getHours(),
		minutes: minutes,
		_date: date
	}
};

Common.prototype.initResendRecoverCode = function () {
	$('#resend-recover-code').click(function () {
		common.redirect('/recover/');
	});
};

Common.prototype.initExample1SliderSwiper = function () {
	var $swiperContainer = $('.example-1__slider-container');
	var swiper;

	if ($swiperContainer.length) {
		swiper = new Swiper($swiperContainer[0], {
			slidesPerView: 3,
			initialSlide: 1,
			navigation: {
				nextEl: '.example-1__next',
				prevEl: '.example-1__prev',
			},
			spaceBetween: 128,
			grabCursor: true,
			preventClicks: false,
			preloadImages: false,
			lazy: true,
			lazyLoadingOnTransitionStart: true
		});
	}
};

Common.prototype.initVisual43SliderSwiper = function () {
	var $swiperContainer = $('.visual-43__slider-container');
	var swiper;

	if ($swiperContainer.length) {
		swiper = new Swiper($swiperContainer[0], {
			slidesPerView: 3,
			initialSlide: 1,
			navigation: {
				nextEl: '.example-1__next',
				prevEl: '.example-1__prev',
			},
			spaceBetween: 118,
			grabCursor: true,
			preventClicks: false,
			preloadImages: false,
			lazy: true,
			lazyLoadingOnTransitionStart: true,
			breakpoints: {
				768: {
					slidesPerView: 1
				}
			}
		});
	}
};

Common.prototype.initHideReadonlyInputCursor = function () {
	$('input[readonly]').focus(function () {
		$(this).blur();
	});
};

Common.prototype.initExamplesMenu = function () {
	var $examplesMenu = $('.examples-1__menu');

	if ($examplesMenu.length) {
		var $examples = $('.examples-1');
		var examplesOffsetTop = $examples.offset().top;
		var scrollTop = $(window).scrollTop();
		var $title = $('.examples-1__title');

		function scrollToCase(id) {
			var $target = $("#" + id);

			$('html, body').animate({
				scrollTop: $target.offset().top
			}, 500);
		}

		function checkOffset(checkOffset) {
			var index = 0;

			checkOffset = checkOffset || false;
			scrollTop = $(window).scrollTop();

			if (checkOffset) {
				examplesOffsetTop = $examples.offset().top;
			}

			if (examplesOffsetTop - 200 > scrollTop) {
				$examplesMenu.fadeOut();
			} else {
				$examplesMenu.fadeIn();
			}

			$title.each(function () {
				var $this = $(this);

				if ($examplesMenu.offset().top + 200 > $this.offset().top) {
					index = $title.index($this);
				}
			});

			$examplesMenu.find('.examples-1__menu-link').removeClass('examples-1__menu-link--active').eq(index).addClass('examples-1__menu-link--active');
		}

		if (!Modernizr.touch) {
			checkOffset();

			$(window).resize(function () {
				checkOffset(true);
			});

			$(window).scroll(function () {
				checkOffset();
			});
		}

		$examplesMenu.find('.examples-1__menu-link').on('click', function () {
			var target = $(this).data('target');

			scrollToCase(target);

			window.location.hash = target;
		});
	}
};

Common.prototype.initExampleMenu = function () {
	var $exampleMenu = $('.example-1__menu-container');

	if ($exampleMenu.length) {
		var scrollTop = $(window).scrollTop();
		var $feature = $('.example-1__feature, .visual-18--join');
		var $window = $(window);

		function checkOffset() {
			scrollTop = $(window).scrollTop();

			if (150 > scrollTop) {
				$exampleMenu.fadeOut();
			} else {
				if ($feature.offset().top > scrollTop + $window.height()) {
					$exampleMenu.fadeIn();
				} else {
					$exampleMenu.fadeOut();
				}
			}
		}

		checkOffset();

		$(window).resize(function () {
			checkOffset(true);
		});

		$(window).scroll(function () {
			checkOffset();
		});
	}
};

Common.prototype.initIsMobile = function () {
	if (typeof isMobile != 'undefined') {
		var $html = $('html');

		if (isMobile.phone) {
			$html.addClass('phone');
		}

		if (isMobile.tablet) {
			$html.addClass('tablet');
		}

		if ((/mac|Mac/i).test(navigator.userAgent || navigator.vendor || window.opera)) {
			$html.addClass('apple-device');
		}

		if (isMobile.android.device) {
			$html.addClass('android-device');
		}

		if (isMobile.any) {
			$html.addClass('mobile-device');
		}
	}
};

Common.prototype.initSmoothScroll = function initSmoothScroll() {
	$('a[href*="#"]:not([href="#"]), .js-smooth-scroll').click(function (e) {
		var stringUrl = $(this).attr('href');
		var $this = $(this);

		if (!stringUrl.match(new RegExp('^(http(s)?\:)', 'gm'))) {
			if (!$this.hasClass('js-change-url')) {
				e.preventDefault();
			}

			if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname || this.dataset.targetId) {
				var target = $(this.hash || ('#' + this.dataset.targetId));
				target = target ? target : $('[name=' + target.slice(1) + ']');

				if (target.length) {
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1000);
				}
			}
		}
	});
};

Common.prototype.initBranch = (function () {
	var _this = null;

	return {
		status: false,
		fc_frame: null,
		banner: null,
		closeBtn: null,
		openAppBtn: null,
		dateSession: localStorage.getItem("branch_banner_session_date") ? new Date(Number(localStorage.getItem("branch_banner_session_date"))) : new Date(),
		dateNow: new Date(),
		openLinkList: [
			'/login/',
			'/signup/',
			'/app/magic/'
		],

		init: function () {
			var isTabletDevice = isMobile.tablet;
			var isMobileDevice = isMobile.phone;
			var pathGet = window.location.pathname;
			var pathGetParams = window.location.href;

			_this = this;
			_this.banner = document.getElementById("js-branch-banner-iframe");

			if (_this.banner) {
				_this.closeBtn = document.getElementById("js-branch-banner-close");
				_this.openAppBtn = document.getElementById("js-branch-banner-open-app");
				_this.overlay = document.getElementsByClassName('js-branch-banner-overlay')[0];

				if (_this.overlay) {
					_this.overlay.addEventListener('click', function (e) {
						if (e.target.classList.contains('js-branch-banner-overlay')) {
							_this.closeBanner();
						}
					})
				}

				/** @type {{
				 * 	experiment_viewed: {
				 *     experiment_id: number,
				 *     experiment_name: string,
				 *     variant_id: number,
				 *     variant_name: string
				 * }}}*/

				_this.status = (_this.dateNow.getTime() >= _this.dateSession.getTime()) && (_this.openLinkList.indexOf(pathGet) >= 0);

				if (pathGetParams.indexOf('iframe=1') > -1 && pathGetParams.indexOf('marketplace') > -1) {
					_this.status = false;
				}

				if ((isTabletDevice || isMobileDevice) && _this.status) {

					if (_this.openLinkList.indexOf(pathGet) >= 0) {
						var js_spacer_signup_layout = document.getElementById("js-spacer-signup-layout");

						if (js_spacer_signup_layout) {
							js_spacer_signup_layout.classList.remove("spacer-signup-layout--hide");
						}
					}

					_this.banner.classList.add("branch-banner-iframe--show", "branch-banner-iframe-experiment--show");

					if (analytics !== "undefined") {
						analytics.track("mobile_popup_showed", {
							source: 'site',
							app_type: isMobile.tablet ? 'Tablet' : isMobile.phone ? 'Mobile' : 'Unknown device',
							deviceOs: navigator.platform || navigator.userAgent || navigator.vendor || 'Unknown OS',
							message: 'open_in_app',
						})
					}

					_this.closeBtn.addEventListener('touchstart', function () {
						_this.closeBanner();
					});

					_this.openAppBtn.addEventListener("touchstart", function () {
						if (this.classList.contains('branch-banner-iframe-experiment__btn')) {
							common.initBranchLink.tryCreateAndOpenBranchLink('blocking open-in-app', 'mobile browser, website');
						} else {
							common.initBranchLink.tryCreateAndOpenBranchLink('control open-in-app', 'mobile browser, website');
						}

						if (analytics !== "undefined") {
							analytics.track("mobile_popup_closed", {
								source: 'site',
								app_type: isMobile.tablet ? 'Tablet' : isMobile.phone ? 'Mobile' : 'Unknown device',
								deviceOs: navigator.platform || navigator.userAgent || navigator.vendor || 'Unknown OS',
								message: 'open_in_app',
							})
						}
					})

					if (window.fcWidget) {
						window.fcWidget.on("widget:loaded", function (resp) {
							if (_this.status) {
								_this.fc_frame = document.getElementById("fc_frame");
								_this.fc_frame.style.transition = "bottom 250ms";
								_this.fc_frame.style.bottom = "100px";
							}
						});
					}
				}
			}
		},

		closeBanner: function () {
			_this.banner.classList.remove("branch-banner-iframe--show", "branch-banner-iframe-experiment--show");
			_this.status = false;
			_this.updateLocalStorage();

			if (!_this.fc_frame) {
				_this.fc_frame = document.getElementById("fc_frame");
			}

			if (_this.fc_frame) {
				_this.fc_frame.style.bottom = "";
			}

			if (analytics !== "undefined") {
				analytics.track("mobile_popup_clicked", {
					source: 'site',
					app_type: isMobile.tablet ? 'Tablet' : isMobile.phone ? 'Mobile' : 'Unknown device',
					deviceOs: navigator.platform || navigator.userAgent || navigator.vendor || 'Unknown OS',
					message: 'open_in_app',
				})
			}
		},

		updateLocalStorage: function () {
			_this.dateSession = new Date().setDate(_this.dateNow.getDate() + 7);
			localStorage.setItem("branch_banner_session_date", _this.dateSession);
		}
	}
})();

Common.prototype.initEmbedLayer = function () {
	$('.example-1__embed-item')
		.on('click', function () {
			$('.example-1__embed-layer', this).hide();
		})
		.on('mouseleave', function () {
			$('.example-1__embed-layer', this).show();
		});
};

Common.prototype.getURLParameter = function (sParam) {
	var sPageURL = window.location.search.substring(1);
	var sURLVariables = sPageURL.split('&');
	for (var i = 0; i < sURLVariables.length; i++) {
		var sParameterName = sURLVariables[i].split('=');
		if (sParameterName[0] == sParam) {
			return sParameterName[1];
		}
	}
};

Common.prototype.sendEventAfterClick = function () {
	$('.js-send-event').each(function () {
		var $button = $(this);
		var $input = $button.parent().find('input');
		var url = $button.attr('href');
		var urlParam = url.indexOf('?') !== -1 ? '&fe=' : '?fe=';
		var newTabLinkTargets = ['_blank', '_parent', '_top']

		$input.keyup(function (e) {
			if (e.keyCode === 13) {
				$button.trigger('click');
			}
		});

		$button.on('click', function (e) {
			e.preventDefault();

			if (window.dataLayer) {
				dataLayer.push({
					event: 'common-contact-form-open',
					hitType: 'event',
					eventCategory: 'Contact_form_open',
					eventAction: $button.data('event-name'),
					eventLabel: window.location.protocol + '//' + window.location.host + window.location.pathname
				});
			}

			setTimeout(function () {
				if ($input.length && $input.val()) {
					url += urlParam + window.btoa(encodeURIComponent($input.val()));
				}

				if (newTabLinkTargets.indexOf($button.attr('target')) !== -1) {
					window.top.open(url);
				} else {
					window.location = url;
				}
			}, 250);
		});
	});
};

//TODO: remove this js - just use get form
Common.prototype.initLoginBtnWithEmail = function () {
	var $forms = $('.rtb-login-btn-with-form');

	$forms.each(function () {
		var $this = $(this);
		var $btn = $this.find('.rtb-login-btn-with-form__btn');
		var $input = $this.find('.rtb-login-btn-with-form__input');
		var locked = false;

		$btn.on('click', function (e) {
			e.preventDefault();

			var $this = $(this);

			if (!locked) {
				locked = true;

				if ($this.data('place') && $this.data('place') !== '') {
					if (typeof analytics !== 'undefined') {
						analytics.track('button_clicked', {
							button_id: $this.attr('id'),
							button_place: $this.data('place'),
							button_text: $this.text()
						});
					}
				}

				setTimeout(function () {
					if ($input.val()) {
						document.cookie = `user_email=${encodeURIComponent($input.val())}; Max-Age=${60 * 60 * 24}; path=/`;
					}
					window.location = e.target.href;
				}, 300);
			}
		});

		$input.keyup(function (e) {
			if (e.keyCode === 13) {
				$btn.trigger('click');
			}
		});
	});
}

Common.prototype.confirmationSocial = (function () {
	var focusToRestore;

	var confirmation = {
		element: null,
		sendBtn: null,
		signup: null,
		title: null,
		form: null,
		events: {},
		init: function () {
			this.element = $('.socialtos').first();
			this.error = this.element.find('.socialtos__btn-error');
			this.sendBtn = this.element.find('.js__socialtos-subscribe');
			this.signup = this.element.find('.js__socialtos-signup');
			this.title = this.element.find('.socialtos__title');
			this.terms = this.element.find('.js__socialtos-terms');
			this.subscribe = this.element.find('.js__socialtos-subscribe');
			this.form = $('.overlay-signup__form-container');

			this.events = {};
		},
		open: function () {
			if (window.RTB.simpleTermsAndConditions == "on") {
				/**
				 * When Experiment is on then we should not show the popup but directly go to social signup
				 * Since this patterns opens and then subribes to success so make this async nature to work
				 * Putting succes call in timeout 0 so it goes end of the call stack
				 */
				setTimeout(() => {
					this.success();	
				}, 0);
        		return;
      		}
			focusToRestore = document.activeElement;
			this.element.addClass('socialtos--visible');
			this.form.addClass('overlay-signup__form-container--hidden');
			this.terms.focus();

			document.addEventListener('keyup', handleEscape);
		},
		close: function (callback) {
			this.element.removeClass('socialtos--visible');

			this.error.removeAttr('role');
			this.error.removeClass('socialtos__btn-error--show');

			this.terms.prop('checked', false);
			this.subscribe.prop('checked', false);

			this.form.removeClass('overlay-signup__form-container--hidden');

			if (focusToRestore) {
				focusToRestore.focus();
			}

			document.removeEventListener('keyup', handleEscape);

			if (callback) {
				callback(this);
			}
		},
		subscribeEvent: function (event, callback) {
			if (!this.events[event]) {
				this.events[event] = [];
			}

			this.events[event].push(callback);
		},
		success: function () {
			for (var i = 0; i < this.events['success'].length; i++) {
				this.events['success'][i]();
			}
		},
		removeUrl: function () {
			this.signup.attr('data-url', null);
		}
	}

	function handleEscape(e) {
		if (e.key === 'Escape' || e.keyCode === 27) {
			confirmation.close();
		}
	}

	return confirmation;
})();

Common.prototype.initSocialBtnsTos = function () {
	var KEY_TAB = 9;
	var $btn = $('.signup__btn');
	var $confirmation = $('.socialtos').first();
	var $close = $confirmation.find('.js__socialtos-close');
	var $login = $confirmation.find('.js__socialtos-login');
	var $signup = $confirmation.find('.js__socialtos-signup');
	var $error = $confirmation.find('.socialtos__btn-error');
	var $terms = $confirmation.find('.js__socialtos-terms');
	var $subscribe = $confirmation.find('.js__socialtos-subscribe');
	var $formContainer = $('.overlay-signup__form-container');

	var $confirmationFocusableElements = $confirmation.find(
		'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');

	var confirmationFirstFocusableElement = $confirmationFocusableElements.get(0);
	var confirmationLastFocusableElement = $confirmationFocusableElements.get(-1);

	$confirmation.customClasses = {
		visible: 'socialtos--visible'
	};

	$formContainer.customClasses = {
		hidden: 'overlay-signup__form-container--hidden'
	};

	function removeCookies() {
		common.cookie.remove('socialterm');
		common.cookie.remove('socialsubscribe');
	}

	function closeOverlay() {
		removeCookies();
		Common.prototype.confirmationSocial.close();
	}

	function socialBtnHandler(el) {
		var $this = $(el);
		var authLink = $this.data('auth');
		var socName = $this.data('soc');
		var pathName = document.location.pathname;

		if (!authLink) {
			return null;
		}

		if (typeof analytics !== 'undefined') {
			analytics.track('fast_registration_clicked', {
				type_of_registration: socName
			});
		}

		common.GTMLayer.sendEvent('fast_registration_clicked', {
			type_of_registration: socName
		});

		$login.attr('href', authLink);
		$signup.attr('data-url', authLink);

		//event for socials bnt on login page only
		if (pathName === '/login/') {
			removeCookies();

			window.location.href = $login.attr('href');
		} else {
			Common.prototype.confirmationSocial.init();
			Common.prototype.confirmationSocial.open();

			Common.prototype.confirmationSocial.subscribeEvent('success', function () {
				if ($signup.attr('data-url')) {
					window.location.href = $signup.attr('data-url');
				}
			});
		}
	}

	$close.on('click', function (e) {
		closeOverlay();
	});

	$confirmation.on('click', function (e) {
		if (e.currentTarget === e.target) {
			closeOverlay();
		}
	});

	$btn.on('click', function (e) {
		socialBtnHandler(this);
	});

	$signup.on('click', function (e) {
		var error = false;

		if (!$terms.prop('checked')) {
			$terms.addClass('socialtos__terms-error');
			$error.addClass('socialtos__btn-error--show');
			$error.attr('role', 'alert');
			common.cookie.remove('socialterm');
			error = true;
		} else {
			error = false;
			$terms.removeClass('socialtos__terms-error');
			$error.removeClass('socialtos__btn-error--show');
			$error.removeAttr('role');
			common.cookie.set('socialterm', true);
		}

		if (!$subscribe.prop('checked')) {
			common.cookie.remove('socialsubscribe');
		} else {
			common.cookie.set('socialsubscribe', true);
		}

		if (!error) {
			Common.prototype.confirmationSocial.success();
		}
	});

	$confirmation.on('keydown', function (e) {
		if (e.key === 'Tab' || e.keyCode === KEY_TAB) {
			if (e.shiftKey) /* shift + tab */ {
				if (document.activeElement === confirmationFirstFocusableElement) {
					confirmationLastFocusableElement.focus();
					e.preventDefault();
				}
			} else /* tab */ {
				if (document.activeElement === confirmationLastFocusableElement) {
					confirmationFirstFocusableElement.focus();
					e.preventDefault();
				}
			}
		}
	});
}

Common.prototype.initLiveEmbedLogin = (function () {
	var isLiveEmbedLogin = /[?&]channel=live-embed(&.*)?$/.test(location.search) && !!window.opener && window.opener.origin === location.origin;

	if (isLiveEmbedLogin) {
		try {
			sessionStorage.setItem('liveEmbedLogin', true);
		} catch (e) {
		}
	}
});

Common.prototype.MrHeader1 = (function () {
	var _this = null;

	return {
		block: document.querySelector('.js-header'),
		mobileMenuBtn: document.querySelector('.js-header-burger'),
		mobileMenuOpenClass: 'mobileMenuOpen',
		fixingPoint: document.querySelector('.js__header-fixing-point'),
		fixedClass: 'fixed',
		initMenuPopup: function () {
			document.body.addEventListener('touchstart', function () {});
		},
		initFixedHeader: function () {
			if (!_this.fixingPoint) {
				return;
			}

			var $point = $(_this.fixingPoint);
			var visibility = VisSense(_this.fixingPoint);

			visibility.monitor({
				visible: function () {
					if (!$point.is(':hidden')) {
						_this.block.classList.remove(_this.fixedClass);
					}
				},
				hidden: function () {
					if (!$point.is(':hidden')) {
						_this.block.classList.add(_this.fixedClass);
					}

				}
			}).start();
		},
		init: function () {
			_this = this;

			if (_this.block) {
				_this.initFixedHeader();

				if (_this.mobileMenuBtn) {
					_this.initMenuPopup();
				}
			}
		}
	}
})();

Common.prototype.HeaderLocalization = (function () {
	var breakpoint = 479;
	var LanguageSwitcher = (function () {
		var _interface = {
			init: function () {
				var mobileLanguageSwitcher = document.querySelector('.js-mobile-language-switcher');
				var mobileLanguageSwitcherPopup = document.querySelector('.header-1__switcher-popup-mobile');
				var languageSwitcherLinks = document.querySelectorAll('.js-switcher-link');
				var mobileLanguagePopupClose = document.querySelector('.js-mobile-popup-close');

				for (var i = 0; i < languageSwitcherLinks.length; i++) {
					languageSwitcherLinks[i].addEventListener('click', function (e) {
						e.preventDefault();
						//get new local for adding cookie
						var newLocal = this.getAttribute('data-local');
						var url = this.getAttribute('href');
						//change cookie
						common.cookie.set('userLocale', newLocal);
						common.GTMLayer.sendEvent('site_language_switcher', {
							site_language: newLocal
						}, function () {
							if (url.length > 0) {
								//go to the link for LPBuilder pages
								document.location.href = document.location.protocol + '//' + document.location.host + url;
							} else {
								//reload page for website pages
								document.location.reload();
							}
						});
					});
				}

				if (mobileLanguageSwitcher && mobileLanguageSwitcherPopup) {
					mobileLanguageSwitcher.addEventListener('click', function () {
						mobileLanguageSwitcherPopup.classList.toggle('show');
					});
				}

				if (mobileLanguagePopupClose && mobileLanguageSwitcherPopup) {
					mobileLanguagePopupClose.addEventListener('click', function () {
						mobileLanguageSwitcherPopup.classList.toggle('show');
					});
				}
			}
		}
		return {
			init: _interface.init
		}
	})();
	var DotsMenu = (function () {
		var _interface = {
			longMenu: null,
			dotsMenu: null,
			navBlock: null,
			headerMenu: null,
			headerAuth: null,
			init: function () {
				_interface.longMenu = document.querySelector('.js-header-1__long-menu');
				_interface.dotsMenu = document.querySelector('.js-header-1__dots-menu');
				_interface.navBlock = document.querySelector('.js-header-nav');
				_interface.headerMenu = document.querySelector('.js-header-1__menu');
				_interface.headerAuth = document.querySelector('.js-header1__auth');
			},
			update: function () {
				_interface.windowWidth = document.documentElement.clientWidth;
				_interface.navBlockWidth = _interface.navBlock.clientWidth;
				_interface.headerMenuWidth = _interface.headerMenu.clientWidth;
				_interface.headerAuthWidth = _interface.headerAuth.clientWidth;
				//for different from mobile
				if (_interface.windowWidth > breakpoint) {
					//check width for show dots menu
					if ((_interface.navBlockWidth - (_interface.headerMenuWidth + _interface.headerAuthWidth)) < 0) {
						//hide long menu and show dots menu
						_interface.longMenu.classList.add('hidden');
						_interface.dotsMenu.classList.remove('hidden');
					}
					//check width for hide dots menu
					//240px - average width long menu
					if ((_interface.navBlockWidth - (_interface.headerMenuWidth + _interface.headerAuthWidth + 240)) > 0) {
						if (!_interface.dotsMenu.classList.contains('hidden')) {
							//hide long menu and show dots menu
							_interface.longMenu.classList.remove('hidden');
							_interface.dotsMenu.classList.add('hidden');
						}
					}
				} else {
					_interface.longMenu.classList.remove('hidden');
					_interface.dotsMenu.classList.add('hidden');
				}
			}
		}
		return {
			init: _interface.init,
			update: _interface.update
		};
	})()
	var _interface = {
		body: null,
		block: null,
		mobileMenuBtn: null,
		mobileMenuAccordionItems: null,
		mobileMenuAccordionItem: null,
		hasSubmenuItems: null,
		submenuList: null,
		submenuLinks: null,
		fixingPoint: null,
		mobileMenuOpenClass: 'mobileMenuOpen',
		fixedClass: 'fixed',
		tags: ['SPAN', 'svg', 'path', 'rect'],
		initMobileMenu: function () {
			_interface.mobileMenuBtn.addEventListener('click', function () {
				_interface.block.classList.toggle(_interface.mobileMenuOpenClass);
				_interface.body.classList.toggle('page_overflow');
			});
			//header mobile menu accordion
			for (var i = 0; i < _interface.hasSubmenuItems.length; i++) {
				_interface.hasSubmenuItems[i].addEventListener('click', function (e) {
					_interface.mobileMenuAccordionItem = this.querySelector('.js-mobile-accordion-menu-item');
					if (e.target.classList.contains('js-mobile-accordion-menu-item') || _interface.tags.includes(e.target.tagName)) {
						_interface.mobileMenuAccordionItem.parentElement.classList.toggle('show');
						if (_interface.mobileMenuAccordionItem.getAttribute('aria-expanded') === 'false') {
							_interface.mobileMenuAccordionItem.setAttribute('aria-expanded', 'true');
						} else {
							_interface.mobileMenuAccordionItem.setAttribute('aria-expanded', 'false');
						}
					}

					if (_interface.mobileMenuAccordionItem.parentElement.classList.contains('show')) {
						document.addEventListener('focusin', function (e) {
							if (document.documentElement.clientWidth > breakpoint) {
								if (e.target.getAttribute('role') !== 'menuitem') {
									_interface.mobileMenuAccordionItem.parentElement.classList.remove('show');
									_interface.mobileMenuAccordionItem.setAttribute('aria-expanded', 'false');
								}
							}
						});
					}
				});
			}
			for (var i = 0; i < _interface.hasSubmenuItems.length; i++) {
				_interface.hasSubmenuItems[i].addEventListener('mouseenter', function () {
					if (document.documentElement.clientWidth > breakpoint) {
						_interface.mobileMenuAccordionItem = this.querySelector('.js-mobile-accordion-menu-item');
						_interface.mobileMenuAccordionItem.setAttribute('aria-expanded', true);
						this.classList.add('show');
					}
				});
				_interface.hasSubmenuItems[i].addEventListener('mouseleave', function () {
					if (document.documentElement.clientWidth > breakpoint) {
						_interface.mobileMenuAccordionItem = this.querySelector('.js-mobile-accordion-menu-item');
						_interface.mobileMenuAccordionItem.setAttribute('aria-expanded', false);
						this.classList.remove('show');
					}
				});
			}
		},
		initFixedHeader: function () {
			if (!_interface.fixingPoint) {
				return;
			}
			var $point = $(_interface.fixingPoint);
			var visibility = VisSense(_interface.fixingPoint);
			visibility.monitor({
				visible: function () {
					if (!$point.is(':hidden')) {
						_interface.block.classList.remove(_interface.fixedClass);
					}
				},
				hidden: function () {
					if (!$point.is(':hidden')) {
						_interface.block.classList.add(_interface.fixedClass);
					}
				}
			}).start();
		},
		init: function () {
			_interface.body = document.querySelector('body');
			_interface.block = document.querySelector('.js-header');
			_interface.mobileMenuBtn = document.querySelector('.js-header-burger');
			_interface.mobileMenuAccordionItems = document.querySelectorAll('.js-mobile-accordion-menu-item');
			_interface.hasSubmenuItems = document.querySelectorAll('.js-has-submenu');
			_interface.submenuList = document.querySelectorAll('.js-submenu-list');
			_interface.fixingPoint = document.querySelector('.js__header-fixing-point');

			DotsMenu.init();
			DotsMenu.update();

			if (_interface.block) {
				_interface.initFixedHeader();
				if (_interface.mobileMenuBtn) {
					LanguageSwitcher.init();
					_interface.initMobileMenu();
				}
			}
			//resize window
			window.addEventListener('resize', function () {
				DotsMenu.update();
			});
		}
	}
	return {
		init: _interface.init
	};
})();

Common.prototype.FooterLocalization = (function () {
	var _interface = {
		menuGroups: [],

		preparation: function () {
			_interface.menuGroups = document.querySelectorAll('.js-footer-group-menu');
		},

		initMobileMenu: function () {
			if (_interface.menuGroups) {
				for (var i = 0; i < _interface.menuGroups.length; i++) {
					_interface.menuGroups[i].addEventListener('click', function () {
						this.classList.toggle('opened');
					});
				}
			}
		},

		init: function () {
			_interface.preparation();
			_interface.initMobileMenu();
		},
	}

	return {
		init: _interface.init
	};
})();

Common.prototype.MrHellobar1 = (function () {
	var _this = null;

	return {
		forms: document.querySelectorAll('.mr-form-1'),
		init: function () {
			_this = this;

			if (_this.forms && _this.forms.length) {
				Array.prototype.forEach.call(_this.forms, function (form) {
					var $form = $(form); //heil jquery!
					var $name = $form.find('input[name="name"]');
					var $email = $form.find('input[name="email"]');
					var $agreed = $form.find('input[name="agreed"]');
					var $agreedWrap = $agreed.closest('.mr-form-1__checkbox');
					var errorClass = 'error';

					$form.on('submit', function (e) {

						if (!$agreed.prop('checked')) {
							$agreedWrap.addClass(errorClass);
						} else {
							$agreedWrap.removeClass(errorClass);
						}

						if ($name.val().length > 0 && $email.val().length > 0 && $agreed.prop('checked')) {

						} else {
							e.preventDefault();
						}
					});
				});
			}
		}
	}
})();

Common.prototype.loginFormValidation = (function () {
	var _interface = {
		form: null,
		inputs: [],
		input: null,
		inputType: null,
		inputContainer: null,
		error: null,
		errorMessageField: null,
		typeError: null,
		errorMessage: null,
		errors: [],

		init: function () {
			//form send button
			_interface.form = document.querySelector('.js-form');
			//get fields
			_interface.inputs = document.querySelectorAll('.signup__input-text');

			//add focus state to first input with error
			for (var i = 0; i < _interface.inputs.length; i++) {
				if (_interface.inputs[i].getAttribute('aria-invalid') !== 'false') {
					_interface.inputs[i].focus();
					break;
				}
			}

			_interface.form.addEventListener('submit', function (e) {
				//check fields
				for (var i = 0; i < _interface.inputs.length; i++) {
					_interface.input = _interface.inputs[i];
					//input type with error
					_interface.inputType = _interface.input.name;

					//check email
					if (_interface.inputType === 'email') {
						if (_interface.input.validity.valueMissing) {
							_interface.typeError = 'emptyField';
							_interface.handleError();

							e.preventDefault();
						} else if (_interface.input.validity.typeMismatch) {
							_interface.typeError = 'incorrectField';
							_interface.handleError();
							e.preventDefault();
						} else {
							_interface.clearError();
						}
					}

					if (_interface.inputType === 'password') {
						if (_interface.input.validity.valueMissing) {
							_interface.typeError = 'emptyField';
							_interface.handleError();

							e.preventDefault();
						} else {
							_interface.clearError();
						}
					}
				}

				//add focus state to first input with error
				for (var i = 0; i < _interface.inputs.length; i++) {
					if (_interface.inputs[i].getAttribute('aria-invalid') !== 'false') {
						_interface.inputs[i].focus();
						break;
					}
				}
			})

		},

		handleError: function () {

			_interface.form.classList.add('error');
			_interface.input.classList.add('signup__input-text--error');
			_interface.input.setAttribute('aria-invalid', true);

			//create error message
			_interface.errorMessageCreator();

			//show error
			_interface.inputContainer = _interface.input.closest('.signup__input-wrap');

			if (_interface.inputContainer !== undefined) {
				_interface.error = _interface.inputContainer.querySelector('.js-signup__error-wrap-login');

				_interface.errorMessageField = _interface.error.querySelector('.js-error');
				_interface.errorMessageField.textContent = _interface.errorMessage;
				_interface.error.classList.remove('hidden');
			}
		},

		errorMessageCreator: function () {
			if (_interface.inputType === 'email') {
				//check type error
				if (_interface.typeError === 'emptyField') {
					_interface.errorMessage = window.RTB.emptyEmail || 'Please enter your email address.';
				} else {
					_interface.errorMessage = window.RTB.incorrectEmailError || 'The email you entered is incorrect.';
				}
			} else {
				_interface.errorMessage = window.RTB.emptyPassword || 'Please enter your password.';
			}
		},

		clearError: function () {
			_interface.inputContainer = _interface.input.closest('.signup__input-wrap');
			_interface.input.classList.remove('signup__input-text--error');

			if (_interface.inputContainer !== undefined) {
				_interface.error = _interface.inputContainer.querySelector('.js-signup__error-wrap-login');
				_interface.error.classList.add('hidden');
				_interface.errorMessageField = _interface.error.querySelector('.js-error');
				_interface.errorMessageField.textContent = '';
			}

			_interface.input.setAttribute('aria-invalid', false);
		},
	}

	return {
		init: _interface.init
	};
})();

Common.prototype.authFormValidation = (function () {
	var _interface = {
		input: null,
		form: null,
		errorClass: null,
		errors: [],
		errorMessage: null,
		emptyEmailErrorMsg: null,
		incorrectEmailErrorMsg: null,

		init: function (input, errorClass, emptyEmailErrorMsg, incorrectEmailErrorMsg) {
			_interface.input = input;
			_interface.errorClass = errorClass;
			_interface.form = document.querySelector('.js-form');
			_interface.errors = document.querySelectorAll('.js-signup__error-wrap-login');
			_interface.emptyEmailErrorMsg = emptyEmailErrorMsg;
			_interface.incorrectEmailErrorMsg = incorrectEmailErrorMsg;

			if (_interface.input.classList.contains(_interface.errorClass)) {
				_interface.input.focus();
			}

			_interface.form.addEventListener('submit', function (e) {
				if (!_interface.input.validity.valid) {
					_interface.handleError();
					e.preventDefault();
				}
			})
		},

		handleError: function () {
			_interface.input.classList.add(_interface.errorClass);
			_interface.input.setAttribute('aria-invalid', true);

			if (_interface.input.validity.valueMissing) {
				for (var i = 0; i < _interface.errors.length; i++) {
					_interface.errors[i].classList.remove('hidden');
					_interface.errorMessage = _interface.errors[i].querySelector('.js-error');
					_interface.errorMessage.textContent = _interface.emptyEmailErrorMsg;
				}

			} else if (_interface.input.validity.typeMismatch) {
				for (var i = 0; i < _interface.errors.length; i++) {
					_interface.errors[i].classList.remove('hidden');
					_interface.errorMessage = _interface.errors[i].querySelector('.js-error');
					_interface.errorMessage.textContent = _interface.incorrectEmailErrorMsg;
				}
			}

			_interface.input.focus();
		}
	}

	return {
		init: _interface.init
	};
})();

Common.prototype.templateActionsWorker = {
	init: function () {
		this.initForms();

		var isUserAuthorized = !!common.config.user.id;
		var $accountPickerModal = this.initAccountPickerModal();

		$('.js__create-example-template').on('click', function (e) {
			e.preventDefault();
			var $btn = $(this);
			$btn.addClass('loading');

			if (isUserAuthorized) {
				return common.templateActionsWorker.runAuthorizedCopyFlow($btn, $accountPickerModal);
			}

			return common.templateActionsWorker.runUnauthorizedCopyFlow($btn);
		});
	},

	initForms: function () {
		var $forms = $('.js__create-template-form');

		$forms.each(function () {
			var $this = $(this),
				$input = $this.find('.js__create-template-input'),
				$button = $this.find('.js__create-example-template');

			$input.keyup(function (e) {
				if (e.keyCode === 13) {
					$button.trigger('click');
				}
			});
		});
	},

	doCopy: function ($btn, copyBoardAccountId, workspaceKey) {
		var strUtm = $btn.data('utm') || '',
			place = $btn.data('place') || '',
			btnText = $btn.data('text') || this.innerText || '',
			$parent = $btn.parents('.js__create-template-form'),
			$input = $parent.find('.js__create-template-input'),
			href = $btn.attr('href'),
			templateId = $btn.data('template-id'),
			templateName = $btn.data('template-name');

		common.cookie.set('copyBoardId', templateId);

		if (copyBoardAccountId) {
			common.cookie.set('copyBoardAccountId', copyBoardAccountId);
		}

		if (typeof analytics !== 'undefined') {
			analytics.track('start_with_template', {
				example_name: templateName,
				example_id: templateId,
				button_place: place,
				button_text: btnText
			});
		}

		if (window.dataLayer && place.length > 0) {
			dataLayer.push({
				event: 'ga-event',
				hitType: 'event',
				eventCategory: 'start_with_template',
				eventAction: place,
				eventLabel: btnText
			});
		}
		setTimeout(function () {
			if ($parent.length) {
				if ($input.val()) {
					document.cookie = `user_email=${encodeURIComponent($input.val())}; Max-Age=${60 * 60 * 24}; path=/`;
				}
				window.location = href;
			} else {
				if ($btn.hasClass('is-direct-button')) {
					window.location = href;
				} else {
					/* Если не авторизованы */
					if (!common.config.user.id) {
						if (common.cookie.get('isRegistered')) {
							common.redirect('/login/' + strUtm);
						} else {
							common.redirect('/signup/' + strUtm);
						}
					}

					common.redirect(workspaceKey ? '/s/' + workspaceKey + '/app/' : '/app/');
				}
			}

			$btn.removeClass('loading');
		}, 300);
	},

	runUnauthorizedCopyFlow: function ($btn) {
		return common.templateActionsWorker.doCopy($btn);
	},

	runAuthorizedCopyFlow: function ($btn, $accountPickerModal) {
		if (analytics) {
			analytics.track('start_with_template', {
				example_name: $btn.data('template-name'),
				example_id: $btn.data('template-id'),
				button_place: $btn.data('place'),
				button_text: $btn.text().trim()
			});
		}

		if (dataLayer) {
			dataLayer.push({
				event: 'ga-event',
				hitType: 'event',
				eventCategory: 'start_with_template',
				eventAction: $btn.data('place'),
				eventLabel: $btn.text().trim()
			});
		}

		common.GTMLayer.sendEvent('start_with_template', {
			example_name: $btn.data('template-name'),
			example_id: $btn.data('template-id'),
			button_place: $btn.data('place'),
			button_text: $btn.text().trim()
		})

		function copyBoardToAccount(accountId, workspaceKey) {
			return common.templateActionsWorker.doCopy($btn, accountId, workspaceKey);
		}

		function onAccountPickerLoaded(accountsIds, workspaceKey) {
			if (accountsIds.length > 1) {
				$btn.removeClass('loading');
			} else {
				// if user has only one account
				return common.templateActionsWorker.doCopy($btn, accountsIds[0], workspaceKey);
			}
		}

		return this.initAccountPicker($accountPickerModal, copyBoardToAccount, onAccountPickerLoaded);
	},

	initAccountPickerModal: function () {
		var $accountPickerModal = $('<div class="account-picker-modal"></div>');
		$('body').append($accountPickerModal);

		return $accountPickerModal;
	},

	initAccountPicker: function ($modal, copyBoardToAccount, onLoaded) {
		var $accountPicker = $(
			'<iframe id="account-picker" name="account-picker" src="' + window.location.origin + '/app/account-picker/?filterCanCreateBoard=1"></iframe>'
		);

		function onPickerLoad(accountsIds, workspaceKey) {
			if (accountsIds.length > 1) {
				$modal.addClass('account-picker-modal--visible');

				if (typeof analytics !== 'undefined') {
					analytics.track('account_picker_shown', {
						opened_from: 'site'
					});
				}
			}

			return onLoaded(accountsIds, workspaceKey);
		}

		function onPickerClose() {
			$modal.removeClass('account-picker-modal--visible');
			common.templateActionsWorker.accountPickerMessagesListener.destroy();
			$modal.html('');
		}

		function onPickerSubmit(accountId, workspaceKey) {
			copyBoardToAccount(accountId, workspaceKey);
			onPickerClose();
		}

		common.templateActionsWorker.accountPickerMessagesListener.run(onPickerLoad, onPickerClose, onPickerSubmit);
		$modal.append($accountPicker);
	},

	accountPickerMessagesListener: {
		listener: null,

		createListener: function (onLoad, onCancel, onSubmit) {
			return function (msg) {
				try {
					var data = JSON.parse(msg.data);

					if (!data.type) {
						return;
					}

					switch (data.type) {
						case 'account-picker/loaded':
							if (typeof onLoad === 'function') {
								onLoad(data.payload.accountsIds, data.payload.workspaceKey);
							}
							break;

						case 'account-picker/submit':
							if (typeof onSubmit === 'function') {
								if (typeof analytics !== 'undefined') {
									analytics.track('account_selected_in_account_picker', {
										chosen_account_id: data.payload.accountId,
										accounts_list_index: data.payload.accountsListIndex
									});
								}

								onSubmit(data.payload.accountId, data.payload.workspaceKey);
							}
							break;

						case 'account-picker/cancel':
							if (typeof onCancel === 'function') {
								onCancel();
							}
							break

						default:
							break;
					}

				} catch (e) {
					// just catch invalid events, nothing to do
				}
			}
		},

		run: function (onLoad, onCancel, onSubmit) {
			if (!this.listener) {
				this.listener = this.createListener(onLoad, onCancel, onSubmit);
			}

			window.addEventListener('message', this.listener);
		},
		destroy: function () {
			window.removeEventListener('message', this.listener);
			this.listener = null;
		}
	},
}

Common.prototype.GoogleOptimizeEventHub = (function () {
	return {
		collection: [],
		init: function (experiment_id, experiment_name, variations) {
			var _this = this;
			var delay = 300;
			var timer = setInterval(function () {
				if (typeof google_optimize.get(experiment_id) !== 'undefined') {
					for (var i = 0; i < _this.collection.length; i++) {
						_this.collection[i]({
							experiment_id: experiment_id,
							experiment_name: experiment_name,
							variation_id: parseInt(google_optimize.get(experiment_id)),
							variation_name: variations[parseInt(google_optimize.get(experiment_id))]
						});
						clearInterval(timer);
					}
				}
			}, delay);
		},
		subscribeEvent: function (callback) {
			this.collection.push(callback);
		}
	}
})();

Common.prototype.GoogleOptimizeEventHub.subscribeEvent(function (data) {
	if (typeof analytics !== 'undefined') {
		analytics.track('experiment_viewed', data);
	}
});

Common.prototype.GTMLayer = (function () {
	var gtm = {
		elements: 'js__event-link-to-gtm',
		initButtonClick: function () {
			this.elements = document.getElementsByClassName(this.elements);

			for (var i = 0; i < this.elements.length; i++) {
				this.elements[i].addEventListener('click', function (e) {
					gtm.buttonClick(e, this);
				});
			}
		},
		buttonClick: function (event, element) {
			event.preventDefault();

			var keys = Object.keys(element.dataset);
			var values = Object.values(element.dataset);
			var data = {};

			if (element.innerText) {
				data.button_text = element.innerText;
			}

			for (var i = 0; i < keys.length; i++) {
				if (keys[i].indexOf('gtm') === 0) {
					data[keys[i].slice(3).toLocaleLowerCase()] = values[i];
				}
			}

			this.sendEvent(data['event'] || 'button_clicked', data, function () {
				if (element.href) {
					if (element.getAttribute('target')) {
						window.open(element.href, element.getAttribute('target'))
					} else {
						window.location = element.href;
					}
				}
			})
		},
		sendEvent: function (event, data, callback, timeout) {
			if (window.dataLayer && event && data) {
				timeout = timeout || 300;
				data.event = event;
				window.dataLayer.push(data);

				if (callback) {
					setTimeout(function () {
						callback();
					}, timeout)
				}
			}
		}
	};

	gtm.initButtonClick();

	return gtm;
})();

Common.prototype.initBranchLink = (function () {
	var _this = null;

	return {
		tryCreateAndOpenBranchLink: function (campaign, channel, url) {
			_this = this;

			var tryId = _this.tryCreateAndOpenBranchLink['tryId'] || 1;
			var anonymousId = common.cookie.get('ajs_anonymous_id').replace(/"/g, '') || '';
			var linkData = {
				campaign: campaign || '',
				channel: channel || '',
				feature: '',
				stage: '',
				tags: [],
				alias: '',
				make_new_link: true,
				data: {
					rtb_browser_url: url || (common.config.user.redirect || window.location.href),
					rtb_anonymous_id: anonymousId
				}
			}

			tryId++;
			_this.tryCreateAndOpenBranchLink['tryId'] = tryId;

			window.branch.link(linkData, function (err, link) {
				if (_this.tryCreateAndOpenBranchLink['tryId'] > tryId) {
				} else {
					document.location.href = link || err;
				}
			});
		}
	}
})();

Common.prototype.cookieConsentBannerPosition = (function () {
	var _this = null;

	return {
		chat: null,
		zenChat: null,
		cookieBanner: null,
		intervalId: null,
		hubspotShiftedClass: 'shiftedByHubspot',
		zendeskShiftedClassMobile: 'shiftedByZendeskMobile',
		zendeskShiftedClassDesktop: 'shiftedByZendeskDesktop',
		limit: 20,
		count: 0,
		init: function () {
			_this = this;

			_this.intervalId = setInterval(function () {
				if (_this.limit > _this.count++) {
					_this.chat = document.querySelector('#hubspot-messages-iframe-container');
					_this.zenChat = document.querySelector('#webWidget');
					_this.cookieBanner = document.querySelector('#hs-eu-cookie-confirmation');

					if (_this.chat && _this.cookieBanner) {
						_this.cookieBanner.classList.add(_this.hubspotShiftedClass);

						clearInterval(_this.intervalId);
					} else if (_this.zenChat && _this.cookieBanner) {

						if (Modernizr.touch) {
							_this.cookieBanner.classList.add(_this.zendeskShiftedClassMobile);
						} else {
							_this.cookieBanner.classList.add(_this.zendeskShiftedClassDesktop);
						}

						clearInterval(_this.intervalId);
					}
				} else {
					clearInterval(_this.intervalId);
				}
			}, 500);
		}
	}
})();

Common.prototype.sendEventsToEventHubAfterABTestInit = (function () {
	var _this = null;

	return {
		section: null,
		abData: null,
		init: function () {
			_this = this;

			_this.section = document.querySelector('[data-experiment]');

			if (_this.section) {
				_this.abData = JSON.parse(_this.section.dataset.experiment);

				if (typeof analytics !== 'undefined') {
					analytics.track('experiment_viewed', _this.abData.experiment_viewed);
				}
			}
		}
	}
})();

Common.prototype.loginWatcher = (function () {
	var _sessionStorage = function () {
		var timer = setInterval(function () {
			console.log('Login watcher -> watch');

			if (common.cookie.get('userInfo')) {
				clearInterval(timer);

				console.log('Login watcher -> Redirect on /app/"');

				window.location = '/app/';
			}
		}, 500)
	}

	var _lastPage = function (lastPage, lastUserID) {
		var url = atob(lastPage).replace(new RegExp('(http|https)(:?\\/\\/)(.+?)(\\/.+)', 'gm'), function (args, a1, a2, a3, a4) {
			if (!a3 || a3 !== document.domain) {
				return null;
			}

			return a4;
		})

		if (!url) {
			return;
		}

		var timer = setInterval(function () {
			var userInfo = common.cookie.get('userInfo');

			if (!userInfo) {
				return;
			}

			userInfo = JSON.parse(userInfo);

			if (userInfo.id === lastUserID) {
				window.location = url;
			} else {
				window.location = "/app/";
			}

			clearInterval(timer);
		}, 1500);
	}

	return {
		init: function () {
			console.log('Login watcher -> Init');
			var urlSearchParams = new URLSearchParams(new URL(window.location).search);
			var lastUserID = common.cookie.get('prevUserId');

			if (common.cookie.get('userInfo')) {
				console.log('Login watcher -> cookie userInfo is found. Finish work');
				return;
			}

			if (urlSearchParams.has('channel') && urlSearchParams.get("channel") === "live-embed") {
				console.log('Login watcher -> query parameter "channel === live-embed". Finish work');
				return;
			}

			if (window.sessionStorage.getItem('lastSessionInfo') !== null) {
				console.log('Login watcher -> isset "lastSessionInfo"');
				_sessionStorage();
				return;
			}

			if (urlSearchParams.has('lastPage')) {
				console.log('Login watcher -> query parameter lastPage is isset"');
				return _lastPage(urlSearchParams.get('lastPage'), lastUserID);
			}

			console.log("Login watcher -> doesn't start.");
		}
	};
})();

Common.prototype.notificationBanner = (function () {
	return {
		init: function () {
			var banners = document.querySelectorAll('.js-notification-banner');

			if (banners) {
				[].forEach.call(banners, function (banner) {
					var closeButton = banner.querySelector('.js-close-notification-banner');

					closeButton.addEventListener('click', function () {
						banner.classList.add('is-hidden');
						common.cookie.set(banner.getAttribute('id'), 'off');
					});
				});
			}
		}
	}
})();

Common.prototype.formLabels = function () {
	var _interface = {
		inputs: document.querySelectorAll('.signup__input-text'),
		className: 'is-focused',
		events: [
			'focus',
			'focusout',
		],
		focusOn: function (element) {
			element.classList.add(_interface.className)
		},
		focusOff: function (element) {
			element.classList.remove(_interface.className)
		},
		init: function () {
			_interface.inputs.forEach(function (input) {
				var wrapper = input.closest('.signup__field-wrapper');

				if (input.value !== '') {
					_interface.focusOn(wrapper)
				}

				_interface.events.forEach(function (event) {
					input.addEventListener(event, function (e) {
						if (e.type === 'focusout' && e.target.value === '') {
							if (typeof e.relatedTarget !== undefined && e.relatedTarget && e.relatedTarget.classList.contains('signup__submit')) {
								return
							}

							_interface.focusOff(wrapper)
						} else {
							_interface.focusOn(wrapper)
						}
					})
				});

				input.addEventListener('input', function () {
					_interface.focusOn(wrapper)
				});
			});
		},
	}

	_interface.init()
}
